import { isNil } from "lodash";
import { useSession } from "next-auth/react";

import { UserRole, useGetPatientInfoQuery } from "graphql/generated";
import graphQLClient from "graphql/react-query";

export const useCheckPatientLogIn = () => {
  const { data: session, status } = useSession();

  const user = session?.user;
  const isGuest = session?.user?.userType !== UserRole.Patient;

  const { data: patientData, isLoading } = useGetPatientInfoQuery(
    graphQLClient,
    {},
    { enabled: !isNil(user), refetchOnWindowFocus: false }
  );

  const isSessionLoading = status === "loading" || isLoading;

  return { isGuest, user, patientInfo: patientData?.getPatientInfo, isSessionLoading };
};
